<template>
  <div>
    <div class="modal modal--welcomeback modal--zero-balance " id="resubscribe_with_pin" style="display: block;">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close" @click="$emit('close')"></i></button>
        <div class="modal__header">
        </div>
        <div class="modal__body">
          <h1>{{ getTranslations.home_modals_resubscribepin_you_are_close }}</h1>
          <img class="modal_icon_main" src="static/images/re_subscribe.png" alt="">
          <p>{{ getTranslations.home_modals_resubscribepin_we_sent }}</p>
          <form action="">
            <div class="form-group" :class="[ !hasErrors ? '' : 'has-warning' ]">
              <input type="text" class="form-group__textfield phone_input" :placeholder="getTranslations.home_modals_resubscribepin_enter_the" @keyup="check" v-model="pin"/>
              <span v-show="message && pin && hasErrors" class="form-group__feedback">{{ message }}</span>
            </div>
            <input type="submit" id="submitBtn" :value="getTranslations.home_modals_resubscribepin_confirm" class="ti_btn--main" :class="[ !hasErrors ? '' : 'deactivated' ]" @click.prevent="sendPin">
          </form>
          <span class="terms">{{ getTranslations.home_modals_resubscribepin_by_clicking_resubscribe }}<br>
            <span class="make_it_bold"><a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')">
              {{ getTranslations.home_modals_resubscribepin_terms_and_conditions }}</a>
            </span>{{ getTranslations.home_modals_resubscribepin_of_service }} </span>
        </div>
      </div>
    </div>
    <div class="overlay"></div>
  </div>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import loading from '@/components/home/modals/Loading';
import IntegrationMixin from '@/common/mixins/integration';
import modals from '../../../common/modals';
import WelcomeReturningUnsub from './WelcomeReturningUnsub';

export default {
  // modal_resubscribe_pin.html
  name: 'resubscribe-via-pin',
  mixins: [IntegrationMixin],
  data() {
    return {
      nextPage: '',
      pin: '',
      message: '',
      hasErrors: false,
    };
  },
  components: {
    WelcomeReturningUnsub,
    loading,
  },
  created() {
    if (this.integrationHeader === this.availableIntegrations.CROSS_IRAQ.name && this.userDetails.operatorName === 'KOREK_IRQ') {
      this.ti = this.generateValue();
      this.ts = this.secondsEpoch();
      /* eslint-disable */
      const params = {ti: this.ti, ts: this.ts, te: '#submitBtn', servicename: 'KnowYourCountry', merchantname: 'windowtechnologies', type: 'pin'};
      const paramString = new URLSearchParams(params);
      const url = `https://korek-he.trendy-technologies.com/dcbprotect.php?action=script&${paramString.toString()}`;
      if (sessionStorage.getItem('isRun') === 'true') {
        $.get(url, function (data) {
          console.log(data);
          let scriptToAdd = document.createElement('script');
          scriptToAdd.type = 'text/javascript';
          scriptToAdd.id = 'korek_response';
          // Create contents of the script
          let inlineScript = document.createTextNode("if(sessionStorage.getItem('isRun') === 'true') {\n");
          scriptToAdd.appendChild(inlineScript);
          inlineScript = document.createTextNode(data.s);
          scriptToAdd.appendChild(inlineScript);
          inlineScript = document.createTextNode("\n}");
          scriptToAdd.appendChild(inlineScript);
          document.head.appendChild(scriptToAdd);
          let tag = document.createElement("script");
          tag.type = 'text/javascript';
          tag.id = 'db_response';
          inlineScript = document.createTextNode("if(sessionStorage.getItem('isRun') === 'true') {\n");
          tag.appendChild(inlineScript);
          inlineScript = document.createTextNode("var event = new Event('DCBProtectRun');\n");
          tag.appendChild(inlineScript);
          inlineScript = document.createTextNode("document.dispatchEvent(event); \n}");
          tag.appendChild(inlineScript);
          inlineScript = document.createTextNode("sessionStorage.setItem('isRun', 'false');");
          tag.appendChild(inlineScript);
          document.head.appendChild(tag);
        });
      }
      if (document.getElementById('korek_response')) {
        document.getElementById('korek_response').remove();
        document.getElementById('db_response').remove();
        sessionStorage.setItem('isRun', 'true');
      }
      /* eslint-enable */
    }
  },
  methods: {
    ...mapActions('profile', [
      'sendReOptinPin',
      'getUserLoginDetails',
    ]),
    ...mapMutations('common', [
      'storeModalForSettings',
      'storeModalForStore',
      'storeModalForHomePage',
    ]),
    hasAsync() {
      const activeIntegration = this.getIntegrationByName();
      return activeIntegration && activeIntegration.value.hasAsync;
    },
    generateValue() {
      // eslint-disable-next-line
      return 1001 + '-' + Math.floor(Math.random() * Date.now()) + '-' + Math.floor(Math.random() * Date.now());
    },
    secondsEpoch() {
      return Math.floor(Date.now() / 1000);
    },
    check() {
      const validPinRegex = /^[0-9]{0,8}$/;
      const validPin = this.pin.match(validPinRegex);
      if (!validPin) {
        this.message = this.getTranslations.home_modals_resubscribepin_oops;
        this.hasErrors = true;
      } else {
        this.hasErrors = false;
        this.message = '';
      }
    },
    sendPin() {
      // eslint-disable-next-line
      console.log('Send Pin Method');
      if (this.integrationHeader === this.availableIntegrations.CROSS_IRAQ.name) {
        // eslint-disable-next-line
        if (document.getElementById('korek_response')) {
          document.getElementById('korek_response').remove();
          document.getElementById('db_response').remove();
        }
      }
      this.message = '';
      if (this.pin.length >= 4 && this.pin.length <= 8 && !this.hasErrors) {
        // eslint-disable-next-line
        console.log('Send Pin for Resubscribe user Call in 2 step');
        const pinParam = {
          pin: this.pin,
          ti: this.ti,
          ts: this.ts,
        };
        this.sendReOptinPin({ pinObject: pinParam }).then(() => {
          // eslint-disable-next-line
          console.log('Resubscribe user Call in 2 step Reoptin');
          if (this.twoStepVerificationVerified) {
            this.hasErrors = false;
            if (this.hasAsync()) {
              this.showAsyncModal(loading);
              this.hasErrors = false;
              this.$axios.get(`api/getStatusVerificationPin?msisdn=${this.userDetails.msisdn}`).then((response) => {
                const resp = response.data.responseEnum;
                if (resp === 'OPERATION_SUCCESS') {
                  this.showNextModal();
                } else {
                  this.showAsyncModal(null);
                }
              });
            } else {
              this.hasErrors = false;
              this.showNextModal();
            }
          } else if (this.twoStepVerificationWrongPin) {
            this.hasErrors = true;
            this.message = this.getTranslations.home_modals_resubscribepin_oops;
          } else if (this.twoStepVerificationServerError) {
            if (sessionStorage.getItem('toPage') === '/home/settings') {
              this.storeModalForSettings(null);
              modals.hideModal(this);
            } else {
              modals.hideModalForHomeStorePage(this);
            }
          }
        });
      } else {
        this.message = this.getTranslations.home_modals_resubscribepin_oops;
        this.hasErrors = true;
      }
    },
    showAsyncModal(modal) {
      if (sessionStorage.getItem('toPage') === '/home' || sessionStorage.getItem('toPage') === '/home/profile') {
        this.storeModalForHomePage(modal);
      } else if (sessionStorage.getItem('homeCurrentTabPath') === '/home/store') {
        this.storeModalForStore(modal);
      } else {
        this.storeModalForSettings(modal);
      }
    },
    showNextModal() {
      this.getUserLoginDetails().then(() => {
        if (sessionStorage.getItem('toPage') === '/home' || sessionStorage.getItem('toPage') === '/home/profile') {
          this.storeModalForHomePage(WelcomeReturningUnsub);
          modals.showHideModalForHomeStorePage(this);
        } else if (sessionStorage.getItem('toPage') === '/home/store') {
          this.storeModalForStore(WelcomeReturningUnsub);
          modals.showHideModalForHomeStorePage(this);
        } else {
          this.storeModalForSettings(WelcomeReturningUnsub);
          modals.showHideModalForHomePage(this);
        }
      });
    },
  },
  computed: {
    ...mapState('profile', [
      'twoStepVerificationVerified',
      'twoStepVerificationWrongPin',
      'twoStepVerificationServerError',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
    ...mapState('common', [
      'multiOperatorInfo',
      'userDetails',
      'integrationHeader',
      'availableIntegrations',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/modals/ResubscribeViaPin.vue